'use client';

import { useEffect, useRef } from 'react';
import { initSuperflow } from '@usesuperflow/client'

const isDevScope = process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE === 'dev';
const apiKey = process.env.NEXT_PUBLIC_SUPERFLOW_API_KEY;
const projectId = process.env.NEXT_PUBLIC_SUPERFLOW_PROJECT_ID;

export default function SuperFlow() {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return; 
    if (!isDevScope || !apiKey || !projectId) return;

    initSuperflow(apiKey, { projectId });
    initialized.current = true;
  }, []);

  return null;
}
